export default $axios => resource => ({
  fetchSitemapLevels() {
    return $axios.get(`${resource}/sitemap/sitemaplevels`)
  },
  fetchSitemapUrls(data) {
    return $axios.get(`${resource}/sitemap/urls?${data}`)
  },
})
